import React from 'react'
import {Flex} from "./layout"
import ScrollTracker from '../kit/ScrollTracker'
import MenuItemSoon from './_MenuItemSoon'
import Superface from '../Superface'
import Overline from '../components/_Overline'

export default class About extends React.Component{

    constructor(props){
        super(props)
        // console.log(props)
        this.handleScroll = this.handleScroll.bind(this)
    }

    componentWillMount(){
        document.title = 'Contact - Superface'
        this.setState({
            mounted : false
        })
        this.scroll = new ScrollTracker()
        this.timeoutStartScroll = window.setTimeout( () => { this.scroll.start() }, 1000 )
        this.scroll.on( 'scroll', this.handleScroll )
    }

    componentDidMount(){
        this.timeoutMount = setTimeout(() => {
            this.setState({
                mounted : true
            })
        }, 800)
    }

    componentWillUnmount(){
        if( this.timeoutStartScroll ) window.clearTimeout( this.timeoutStartScroll )
        if( this.timeoutMount ) window.clearTimeout( this.timeoutMount )
        this.scroll.destroy()
    }

    handleScroll(e){
        if( Superface.IS_MOBILE_OR_TABLET ) return
        const ratio = this.scroll.positionY / ( window.innerHeight / 2 )

        if( ratio < -2.5 ){
            this.scroll.stop()
            this.scroll.off( 'scroll', this.handleScroll )
            Superface.goTo(Superface.uri('accueil'))
        }
        

    }

    renderCircle(){
        if( !Superface.IS_MOBILE ){
            return(
                <div style={{ width:( Superface.IS_MOBILE ? '20vw' : '15rem'), position:'absolute', bottom:'0', left:'60%'}}>
                    <img src={require('../images/milan-circle.svg')} alt="Pièce de Milan"/>
                </div>
            )
        }
    }

    render(){

        const { contact } = this.props
        // console.log(contact)
        if ( !contact ) return <span></span>

        const textStyle={
            fontSize : ( Superface.IS_MOBILE ? '1.2rem' : '2rem' ),
            margin : 'auto',
            color : 'white',
            maxWidth : '900px',
            width : '70%'
        }

        
        return(
            <Flex className={this.state.mounted ? 'mounted' : ''} id="contact" align='center' justify='center' style={{backgroundColor:'white', width:'100%', height:'100%'}}>
                 <div id="contact-text">
                        <div style={{...textStyle, color:'black', position:'relative'}}>
                            
                            { Superface.field(contact, 'text') }

                            <br/>
                            <br/>
                            <p style={{fontSize:'1.2rem', lineHeight:'2rem'}}>
                                {contact.adresse},<br/> {contact.city}, {contact.country}
                                <br/>
                                {contact.phone}
                                <br/>
                                <a href={'mailto:' + contact.email }>
                                    {contact.email.replace('@', '(at)')}
                                </a>
                                <br/>
                                <br/>
                            </p>

                            <a className="icon icon-md" style={{marginLeft:'-0.5rem'}} href={ Superface.datas().contact.facebook } target="_blank">
                                <img src={require('../images/facebook-black.svg')} alt="facebook"/>
                            </a>
                            
                            <a className="icon icon-md" href={ Superface.datas().contact.instagram  } target="_blank">
                                <img src={require('../images/instagram-black.svg')} alt="instagram"/>
                            </a>

                        </div>
                        
                        <div style={{position:'relative'}} >
                            {this.renderCircle()}
                        </div>

                    </div>

                    <div id="footer" style={{position:'absolute', bottom:0, width:'100%', height:'4rem', borderTop:'1px solid black'}}>
                            
                            <Flex justify="space-around">
                            
                                <div className="footer-link" style={{marginTop:0}}>
                                    <span className="overline-link" onClick={ () => { Superface.goTo( Superface.uri('notre-metier') ) }}>
                                        <Overline>{ Superface.translate('Notre métier') }</Overline>
                                    </span>
                                </div>

                                <div className="footer-link" style={{marginTop:0}}>
                                    <span className="overline-link"  onClick={ () => { Superface.goTo( Superface.uri('matieres') ) }}>
                                        <Overline>{ Superface.translate('Matières') }</Overline>
                                    </span>
                                </div>
                                
                                <div className="footer-link" style={{marginTop:0}}>
                                    {/* <span className="overline-link" onClick={ () => { Superface.goTo( Superface.uri('projets') ) }}>
                                        <Overline>{ Superface.translate('Projets') }</Overline>
                                    </span> */}
                                    <MenuItemSoon display={Superface.translate('Projets')} style={{display:'inline-block',width:'auto'}} />
                                </div>
                            
                            </Flex>
                            
                        </div>

            </Flex>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Contact.js